import { H } from '../highway';

export const getAllPages = () => (window.KOTA || {}).pages || {};

export const getCurrentSlug = () => (H.properties || {}).slug || {};

export const getIndexBySlug = (slug) => {
  const pages = getAllPages();
  let page = pages.filter(obj => obj.slug === slug);
  if (!page[0]) return;
  return page[0].index;
};

export const disableElements = (array) => {
  array.forEach(element => {
    element.classList.add('is-disabled');
    element.setAttribute('disabled', true)
  });
}

export const enableElements = (array) => {
  array.forEach(element => {
    element.classList.remove('is-disabled');
    element.removeAttribute('disabled')
  });
}

export const setGlobalState = (key, value) => {
  window.KOTA = window.KOTA || {};
  window.KOTA[key] = value;
}

export const readGlobalState = (key) => {
  return (window.KOTA || {})[key] || null;
}

export const unifyTouchEvents = (e) => e.changedTouches ? e.changedTouches[0] : e;
